import React, { useContext, useEffect, useState } from "react";

import { IconButton, Paper, makeStyles } from "@material-ui/core";
import { Search } from "@material-ui/icons";
import clsx from "clsx";
import { useHistory, useParams } from "react-router-dom";
import { toast } from "react-toastify";

import { AuthContext } from "../../context/Auth/AuthContext";
import { ReplyMessageProvider } from "../../context/ReplyingMessage/ReplyingMessageContext";
import toastError from "../../errors/toastError";
import apiV2 from "../../services/apiV2";
import openSocket from "../../services/socket-io";
import {
	connectSocket,
	addGoWebSocketMessageHandler,
	addGoWebSocketOpenHandler,
	getGoWebSocket,
} from "../../services/socketv2";
import { TICKET_REALTIME } from "../../helpers/ticketRealtimeEvents";
import { normalizeContactTags } from "../../helpers/normalizeContactTags";
import ContactDrawer from "../ContactDrawer";
import CustomizedTabs from "../CustomizedTabs";
import MessagesList from "../MessagesList";
import TicketAiReportsList from "../TicketAiReportsList";
import SearchDrawer from '../SearchDrawer';
import TicketActionButtons from "../TicketActionButtons";
import TicketHeader from "../TicketHeader";
import FollowUpCountdown from "../FollowUpCountdown";
import TicketInfo from "../TicketInfo";
import { IconSearch } from "../ChatLayout/tailwickChatIcons";

const drawerWidth = 640;

const useStyles = makeStyles((theme) => ({
	root: {
		backgroundColor: theme.palette.background.default,
		display: "flex",
		height: "100%",
		position: "relative",
		overflow: "hidden",
	},

	ticketInfo: {
		// backgroundColor: `${!darkmode ? "202c33" : "#f0f2f5"}`,
		// backgroundColor: "red",
		display: "flex",
		justifyContent: "space-between",
		alignItems: "center",
		width: "100%",
		height: "49px",
		// maxWidth: "50%",
		// flexBasis: "50%",
		[theme.breakpoints.down("sm")]: {
			transform: "scale(0.7)",
			width: "50vw",
		},
	},
	ticketActionButtons: {
		// backgroundColor: `${!darkmode ? "202c33" : "#f0f2f5"}`,
		// backgroundColor: "red",
		maxWidth: "50%",
		// flexBasis: "50%",
		display: "flex",
		alignItems: "center",
		justifyContent: "flex-end",
		[theme.breakpoints.down("sm")]: {
			alignItems: "center",
			justifyContent: "center",
			// maxWidth: "40vw",
		},
		zIndex: 10,
		marginRight: "1em",

	},

	searchMessages: {
		marginLeft: "auto",

		[theme.breakpoints.down("sm")]: {
			transform: "scale(0.7)",
			width: "3vw",
			margin: 0,
		},
	},

	mainWrapper: {
		backgroundColor: theme.mainWrapper.background.default,
		backgroundSize: 1000,
		backgroundImage: theme.backgroundImage,
		flex: 1,
		height: "100%",
		display: "flex",
		flexDirection: "column",
		overflow: "hidden",
		borderTopLeftRadius: 0,
		borderBottomLeftRadius: 0,
		borderLeft: "0",
		marginRight: -drawerWidth,
		transition: theme.transitions.create("margin", {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.leavingScreen,
		}),
	},

	mainWrapperShift: {
		borderTopRightRadius: 0,
		borderBottomRightRadius: 0,
		transition: theme.transitions.create("margin", {
			easing: theme.transitions.easing.easeOut,
			duration: theme.transitions.duration.enteringScreen,
		}),
		marginRight: 0,
	},

	chatBody: {
		flex: 1,
		minHeight: 0,
		display: "flex",
		flexDirection: "column",
		overflow: "hidden",
	},
	legacyMessagesScroll: {
		flex: 1,
		minHeight: 0,
		overflow: "hidden",
		display: "flex",
		flexDirection: "column",
	},
	legacyChatFooter: {
		flex: "none",
		flexShrink: 0,
		width: "100%",
		zIndex: 2,
		backgroundColor: theme.palette.background.default,
		borderTop: `1px solid ${theme.palette.divider}`,
		paddingTop: theme.spacing(0.5),
		paddingBottom: theme.spacing(1),
	},
}));

function Ticket({ ticketId: ticketIdProp, tailwickLayout = false }) {

  const { ticketId: ticketIdParam } = useParams();

  const ticketId = ticketIdProp ?? ticketIdParam;


  const history = useHistory();
  const classes = useStyles();

  const { user } = useContext(AuthContext);

  const [drawerOpen, setDrawerOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [contact, setContact] = useState({});
  const [ticket, setTicket] = useState({});
  const [templateBarStatus, setTemplateBarStatus] = useState(false);
  const [aroundMessages, setAroundMessages] = useState([]);
  const [searchedMessage, setSearchedMessage] = useState(null);
  const [searchLoading, setSearchLoading] = useState(false);
  const [composerTab, setComposerTab] = useState(0);
  const [messagePrivate, setMessagePrivate] = useState(false);
  const [hasAiReports, setHasAiReports] = useState(false);


  const headerPanelStyle = tailwickLayout
    ? undefined
    : {
        backgroundColor:
          localStorage.getItem("darkMode") === "true" ? "#1b1d1d" : "#ffff",
      };

  const handleDrawerOpen = () => {
    setDrawerOpen(true);
  };

  const handleDrawerClose = () => {
    setDrawerOpen(false);
  };

  const handleSearchOpen = () => {
    setSearchOpen(true);
  };

  const handleSearchClose = () => {
    setSearchOpen(false);
  };

  useEffect(() => {
    let cancelled = false;
    if (!ticketId) {
      setHasAiReports(false);
      return undefined;
    }
    (async () => {
      try {
        const { data } = await apiV2.get(`/tickets/${ticketId}/ai-reports`);
        if (!cancelled) {
          setHasAiReports(Array.isArray(data?.reports) && data.reports.length > 0);
        }
      } catch {
        if (!cancelled) setHasAiReports(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [ticketId]);

  useEffect(() => {
    if (!tailwickLayout || !drawerOpen) {
      document.getElementById("drawer-container")?.style.removeProperty(
        "--tailwick-chat-header-height"
      );
      return undefined;
    }

    const container = document.getElementById("drawer-container");
    if (!container) return undefined;

    const syncHeaderHeight = () => {
      const chatHeader = container.querySelector(".tailwick-chat-header--conversation");
      if (!chatHeader) return;
      const height = Math.round(chatHeader.getBoundingClientRect().height);
      if (height > 0) {
        container.style.setProperty("--tailwick-chat-header-height", `${height}px`);
      }
    };

    syncHeaderHeight();
    const rafId = requestAnimationFrame(syncHeaderHeight);

    const chatHeader = container.querySelector(".tailwick-chat-header--conversation");
    let observer;
    if (chatHeader && typeof ResizeObserver !== "undefined") {
      observer = new ResizeObserver(syncHeaderHeight);
      observer.observe(chatHeader);
    }

    window.addEventListener("resize", syncHeaderHeight);

    return () => {
      cancelAnimationFrame(rafId);
      observer?.disconnect();
      window.removeEventListener("resize", syncHeaderHeight);
      container.style.removeProperty("--tailwick-chat-header-height");
    };
  }, [tailwickLayout, drawerOpen, loading, ticket?.id, contact?.id]);

  useEffect(() => {
    setAroundMessages([]);
    setSearchedMessage(null);
    setSearchLoading(false);
    setComposerTab(0);
    setLoading(true);
    setTicket({});
    setContact({});

    let cancelled = false;

    const fetchTicket = async () => {
      try {
        const { data } = await apiV2.get(`/tickets/${ticketId}`);
        if (cancelled) return;
        setContact(normalizeContactTags(data.contact) || {});
        setTicket(data);
      } catch (err) {
        if (!cancelled) toastError(err);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    fetchTicket();

    return () => {
      cancelled = true;
    };
  }, [ticketId]);

  useEffect(() => {
    const socket = openSocket({
      scope: "ticket",
      userId: user.id,
      component: "Ticket",
      companyId: user.companyId ?? "",
    });

    const applyTicketPayload = (data) => {
      if (!data?.ticket) return;
      const isCurrentTicket =
        String(data.ticket?.id ?? data.ticketId) === String(ticketId);
      if (!isCurrentTicket) return;
      if (data.action === "update" || data.action === "updateUnread") {
        setTicket((prev) => (prev ? { ...prev, ...data.ticket } : data.ticket));
        if (data.ticket.contact) {
          setContact((prev) =>
            normalizeContactTags(
              prev ? { ...prev, ...data.ticket.contact } : data.ticket.contact
            )
          );
        }
      }
    };

    socket.on("connect", () => socket.emit("joinChatBox", ticketId));

    socket.on("ticket", (data) => {
      applyTicketPayload(data);

      // Só exclusão real (payload com ticketId, vindo de DeleteTicketService) redireciona.
      if (
        data.action === "delete" &&
        data.ticketId != null &&
        String(data.ticketId) === String(ticketId)
      ) {
        toast.success("Ticket deleted sucessfully.");
        history.push("/tickets");
      }
    });

    socket.on("contact", (data) => {

      if (data.action === "update") {
        setContact((prevState) => {
          if (prevState.id === data.contact?.id) {
            return normalizeContactTags({ ...prevState, ...data.contact });
          }
          return prevState;
        });
      }
    });

    connectSocket({
      userId: user.id,
      companyId: user.companyId,
    });

    const joinGoChat = () => {
      const s = getGoWebSocket();
      if (!s || s.readyState !== WebSocket.OPEN || !ticketId) return;
      s.send(
        JSON.stringify({
          action: "joinChatBox",
          ticketId: Number(ticketId),
        })
      );
    };

    const handleGoMessage = (event) => {
      try {
        applyTicketPayload(JSON.parse(event.data));
      } catch {
        // ignore
      }
    };

    const handleTicketRealtime = (event) => {
      applyTicketPayload(event?.detail);
    };

    const removeGoMessage = addGoWebSocketMessageHandler(handleGoMessage);
    const removeGoOpen = addGoWebSocketOpenHandler(joinGoChat);
    joinGoChat();
    window.addEventListener(TICKET_REALTIME, handleTicketRealtime);

    return () => {
      window.removeEventListener(TICKET_REALTIME, handleTicketRealtime);
      removeGoMessage();
      removeGoOpen();
      socket.disconnect();
    };
  }, [ticketId, history, user?.id, user?.companyId]);

  const MainWrapper = tailwickLayout ? "div" : Paper;
  const mainWrapperProps = tailwickLayout
    ? { className: "tailwick-chat-main" }
    : {
        variant: "outlined",
        elevation: 0,
        className: clsx(classes.mainWrapper),
      };

  return (
    <div
      className={tailwickLayout ? "tailwick-user-chats tailwick-chat-root flex h-full flex-col" : classes.root}
      id="drawer-container"
    >
      <MainWrapper {...mainWrapperProps}>
        <TicketHeader loading={loading} tailwickLayout={tailwickLayout}>
          {tailwickLayout ? (
            <>
              <div className="flex min-w-0 flex-1 items-center gap-2">
                <TicketInfo
                  tailwickLayout
                  contact={contact}
                  ticket={ticket}
                  onClick={() => {
                    handleDrawerOpen();
                    handleSearchClose();
                  }}
                />
              </div>
              <div className="tailwick-header-actions flex shrink-0 items-center gap-2">
                <button
                  type="button"
                  className="btn btn-icon size-8 shrink-0 bg-default-150 text-default-600 hover:bg-default-200 hover:text-primary"
                  onClick={() => {
                    handleSearchOpen();
                    handleDrawerClose();
                  }}
                  aria-label="Buscar mensagens"
                >
                  <IconSearch size={18} />
                </button>
                <TicketActionButtons
                  tailwickLayout
                  ticket={ticket}
                  contact={contact}
                  onOpenContactDrawer={handleDrawerOpen}
                  onTicketUpdated={setTicket}
                />
              </div>
            </>
          ) : (
            <>
          <div
            className={clsx(classes.ticketInfo, tailwickLayout && "tailwick-chat-panel")}
            style={headerPanelStyle}
          >
            <TicketInfo
              contact={contact}
              ticket={ticket}
              onClick={() => {
                handleDrawerOpen();
                handleSearchClose();
              }}
            />
          </div>
          <div
            className={clsx(
              classes.ticketActionButtons,
              tailwickLayout && "tailwick-chat-panel"
            )}
            style={headerPanelStyle}
          >
            <IconButton
              className={classes.searchMessages}
              onClick={() => {
                handleSearchOpen();
                handleDrawerClose();
              }}
            >
              <Search />
            </IconButton>
            <TicketActionButtons
              ticket={ticket}
              contact={contact}
              onTicketUpdated={setTicket}
            />
          </div>
            </>
          )}
        </TicketHeader>

        <FollowUpCountdown ticket={ticket} />

        <ReplyMessageProvider>
          <div
            className={clsx(
              classes.chatBody,
              tailwickLayout && "tailwick-chat-body"
            )}
          >
            <div
              className={
                tailwickLayout
                  ? "tailwick-chat-messages-scroll"
                  : classes.legacyMessagesScroll
              }
            >
              {composerTab === 2 ? (
                <TicketAiReportsList
                  ticketId={ticketId}
                  tailwickLayout={tailwickLayout}
                  onReportsChange={setHasAiReports}
                />
              ) : (
                <MessagesList
                  key={`${ticketId}-${composerTab === 1 ? "ann" : "chat"}`}
                  tailwickLayout={tailwickLayout}
                  contact={contact}
                  ticketId={ticketId}
                  ticketIsStatus={Boolean(ticket.isStatus)}
                  ticketChannel={ticket.channel}
                  connectionChannel={ticket.whatsapp?.channel}
                  isGroup={ticket.isGroup}
                  templateBarStatus={templateBarStatus}
                  setTemplateBarStatus={setTemplateBarStatus}
                  aroundMessages={aroundMessages}
                  setAroundMessages={setAroundMessages}
                  whatsappId={ticket.whatsappId}
                  searchedMessage={searchedMessage}
                  setSearchedMessage={setSearchedMessage}
                  searchLoading={searchLoading}
                  setSearchLoading={setSearchLoading}
                  privateAnnotationsOnly={composerTab === 1}
                  setMessagePrivate={setMessagePrivate}
                />
              )}
            </div>
            <div
              className={
                tailwickLayout ? "tailwick-chat-footer" : classes.legacyChatFooter
              }
            >

              <CustomizedTabs
                tailwickLayout={tailwickLayout}
                ticket={ticket}
                ticketId={ticketId}
                ticketStatus={ticket.status}
                ticketChannel={ticket.channel}
                ticketOwnerId={ticket.userId}
                templateBarStatus={templateBarStatus}
                composerTab={composerTab}
                onComposerTabChange={setComposerTab}
                messagePrivate={messagePrivate}
                hasAiReports={hasAiReports}
              />
            </div>
          </div>
        </ReplyMessageProvider>
      </MainWrapper>

      <ContactDrawer
        tailwickLayout={tailwickLayout}
        open={drawerOpen}
        handleDrawerClose={handleDrawerClose}
        contact={contact}
        loading={loading}
        ticketId={ticket?.id}
      />

      <SearchDrawer
        open={searchOpen}
        handleDrawerClose={handleSearchClose}
        contact={contact}
        ticket={ticket}
        setAroundMessages={setAroundMessages}
        setSearchedMessage={setSearchedMessage}
        searchedMessage={searchedMessage}
        searchLoading={searchLoading}
        setSearchLoading={setSearchLoading}
        tailwickLayout={tailwickLayout}
      />
    </div>
  );
}


export default Ticket;
